<template>
  <div id="app">
    <h1>SUPERMARKET</h1>
    <p id="avg_time_andon">Average Time Andon: {{ averageTimeAndon }} min</p>
    <p v-if="lastScan" >Dernier scan: {{ lastScan.id_kanban }} il y a {{ (timeAndon(lastScan.created_at)) }} min</p>
    <table width="100%" v-if="message" id="andontable">
      <thead>
        <tr>
          <td v-for="i in 13">
            <span v-if="i <= 10 && i > 1"> 0{{ i - 1 }} </span>
            <span v-else-if="i > 1"> {{ i - 1 }} </span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="i in 26">
          <td>S{{ alphabet[i - 1] }}</td>
          <td v-for="j in 12">
            <span v-if="containsWarning(message[(i-1)*99+(j)])">
              <i id="red_sticker"
                  class="fa fa-circle">
              </i>
            </span>

            <span v-for="item in message[(i-1)*99+(j)]">
              <span v-if="item && item.value == 'fast' && item.proceed_at == null">
                <p class="cells_infos">
                  {{ item.id }}
                </p>
                <p class="cells_infos" style=" color: red">
                  {{ timeAndon(item.at) }} min
                </p>
              </span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>  

</template>
<script>

import server from '../../api/server.vue'


export default {
  name: 'Supermarket',
  data() {
    return {
        message: null,
        value: 0,
        warningSeen: false,
        lastScan: false,
        averageTimeAndon: 0,
      };
  },
  methods: {
    clicked: function() {
      this.value = this.value + 1
    },
    getSuperMarket: function() {
      server.getLastScanSM().then(response => {
        this.lastScan = response.data.last_scan
      });
      server.getSupermarket().then(response => {
          this.message = response.data.map
        })
        .catch(function (error) {
          console.log(error);
        });
      server.getAvgtimeAndon().then(response => {
          var sum = 0
          for(var obj in response.data.stats)
          {
            sum += response.data.stats[obj].average_in_m
            this.averageTimeAndon = Math.trunc(sum / response.data.stats.length)
          }
        });
      this.setProtectedTimeout(this.getSuperMarket, 60000);
    },
  },
  mounted: function () {
    // `this` est une référence à l'instance de vm
    this.getSuperMarket()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/supermarket/supermarket.vue